module.exports = __webpack_public_path__ + "static/media/union.c62c3f79.svg";